import { FolderOpenOutlined } from '@mui/icons-material';
import { Box, SxProps, Typography } from '@mui/material';
import React from 'react';

function EmptyState({
  title,
  description,
  sx,
}: {
  title: string;
  description: string;
  sx?: SxProps;
}) {
  return (
    <Box
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
    >
      <FolderOpenOutlined sx={{ color: 'text.secondary' }} fontSize="large" />
      <Typography variant="h6" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {description}
      </Typography>
    </Box>
  );
}

export default EmptyState;
